import { useQuery } from "graphql-hooks";
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Col, Row } from 'reactstrap';
import { PermissionsGate } from '../../../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../../../utilities/constValues';
import Helper from '../../../utilities/helper';
import { ErrorPage } from '../../Shared/ErrorPage';
import { Hero } from "../../Shared/Hero";
import { Loading } from '../../Shared/Loading';
import { MetaTags } from "../../Shared/MetaTags";
import { NavigationCardSet } from '../../Shared/NavigationCards/NavigationCardSet';
import { PermissionsRequired } from '../../Shared/PermissionsRequired';
import { ElectricVehicleTypes } from './ElectricVehicleTypes';
import { MaintenanceAndCost } from './MaintenanceAndCost';
import { OperatingEfficiency } from './OperatingEfficiency';
import { Safety } from './Safety';
import { AnchorLink, PageAnchors } from "../../Shared/PageAnchors";
import { useAPIErrorContext } from '../../../contexts/apiErrorContext';

const CMS_QUERY = `query datoQuery {
    pageData: pageElectricVehicle {
        fieldHeroTitle
        fieldCardNavigationSectionTitle
        fieldNavigationCards {
            id
            fieldCardTitle
            fieldCardLink
            fieldCardContent
            fieldCardImage {
                alt
                url
                title
            }
        }
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
}`;

export const ElectricVehicles = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();
    const location = useLocation();
    const pageAnchors: AnchorLink[] = [{ displayName: "Types", hashLocation: "./#electric-vehicle-types" },
        { displayName: "Operating Efficiency", hashLocation: "./#operating-efficiency" },
        { displayName: "Maintenance and Cost", hashLocation: "./#maintenance-and-cost" },
        { displayName: "Safety", hashLocation: "./#safety" }];


    React.useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.ElectricVehicles}>
                <div className="electricVehicles">
                    <Hero pageTitle={data.pageData.fieldHeroTitle} />
                    <PageAnchors anchorLinks={pageAnchors} />
                    <ElectricVehicleTypes />
                    <OperatingEfficiency />
                    <MaintenanceAndCost />
                    <Safety />
                    <NavigationCardSet PageData={data.pageData} />
                    <MetaTags seoData={data.pageData.seo} />
                </div>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
